module.exports = __webpack_public_path__ + "img/ball_0_black.002fb983.png";